/**
 * @file appointment.js
 *
 * Appointment API Service
 *
 * API calls to /api/v1/appointment.
 * Covers the full appointment lifecycle: create, confirm, complete, cancel, reschedule.
 *
 * HTTP method meanings:
 *   GET    = read data (no changes)
 *   POST   = create new data
 *   PUT    = full update (replace all fields)
 *   PATCH  = partial update (change one or two fields)
 *   DELETE = remove data
 */
import api from "./api";

export const appointmentService = {
  /** Fetch appointments list, optional query params (status, dateFrom, dateTo). */
  getAll: (params) => api.get("/appointment/list", { params }),
  /** Fetch a single appointment by ID. */
  getById: (id) => api.get(`/appointment/${id}`),
  /** Create a new appointment. */
  create: (data) => api.post("/appointment/create", data),
  /** Full update of an appointment. */
  update: (id, data) => api.put(`/appointment/${id}`, data),
  /** Transition CONFIRMADA/ASISTENCIA_CONFIRMADA to COMPLETADA. */
  complete: (id) => api.patch(`/appointment/${id}/complete`),
  /** Transition CONFIRMADA to ASISTENCIA_CONFIRMADA. */
  confirmAttendance: (id) => api.patch(`/appointment/${id}/confirm-attendance`),
  /** Cancel an appointment with a reason. */
  cancel: (id, data) => api.patch(`/appointment/${id}/cancel`, data),
  /** Reschedule to a new date/time. */
  reschedule: (id, data) => api.patch(`/appointment/${id}/reschedule`, data),
  /** Add or update clinical notes on an appointment. */
  addNotes: (id, notes) => api.patch(`/appointment/${id}/notes`, { notes }),
  /** Mark an appointment as NO_ASISTIO (no-show). */
  noShow: (id) => api.patch(`/appointment/${id}/no-show`),
  /** Fetch aggregate stats for the dashboard. */
  getStats: () => api.get("/appointment/stats"),
};
